import {Injectable} from '@angular/core';
import {Actions} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {ActivatedRoute, Router} from '@angular/router';


@Injectable()
export class VeranstaltungInfoPageUiEffects {

    constructor(private actions$: Actions,
                private store$: Store<any>,
                public route: ActivatedRoute,
                public router: Router) {
    }

}
